// Same stable, round-robin selection as cv_builder.mapper. Display only: never
// persist inferred values merely because an editor was opened.
export function effectiveKeySkills(skills = {}) {
    const categories = (skills.categories || []).filter(category => category.items?.length);
    const candidates = [...(skills.highlighted || [])];
    const length = Math.max(0, ...categories.map(category => category.items.length));
    for (let i = 0; i < length; i += 1) categories.forEach(category => {
        if (category.items[i]) candidates.push(category.items[i]);
    });
    const seen = new Set();
    return candidates.map(value => String(value || '').trim()).filter(value => {
        const normalized = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        if (!normalized || value.length > 80 || seen.has(normalized)) return false;
        seen.add(normalized);
        return true;
    }).slice(0, 5);
}

export const normalizeCvFieldPath = path => String(path || '').replace(/\[(\d+)\]/g, '.$1').replace(/^draft\./, '').replace(/\.projects\./g, '.missions.');
export function stepForCvField(path) {
    const value = normalizeCvFieldPath(path);
    if (/^experiences\.\d+\.(missions|project_groups)(\.|$)/.test(value) || /^projects(\.|$)/.test(value)) return 3;
    if (value.startsWith('experiences')) return 2;
    if (value.startsWith('skills')) return 1;
    if (/^(education|languages|certifications|additional_sections)/.test(value)) return 4;
    return 0;
}

export function focusCvField(path, root = document) {
    const targetPath = normalizeCvFieldPath(path);
    if (!targetPath) return false;
    const fields = [...root.querySelectorAll('[data-cv-path]')];
    let target = fields.find(element => [element.dataset.cvPath, ...(element.dataset.cvIncludes || '').split(',')].includes(targetPath))
        || fields.find(element => element.dataset.cvPath.startsWith(`${targetPath}.`));
    if (!target) {
        let parentPath = targetPath;
        while (!target && parentPath.includes('.')) {
            parentPath = parentPath.slice(0, parentPath.lastIndexOf('.'));
            target = fields.find(element => [element.dataset.cvPath, ...(element.dataset.cvIncludes || '').split(',')].includes(parentPath));
        }
    }
    if (!target) return false;
    for (let parent = target.parentElement; parent; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
    }
    target.scrollIntoView?.({ block: 'center', behavior: 'auto' });
    const control = target.matches('input,textarea,select,button,[tabindex]') ? target : target.querySelector('input,textarea,select,button');
    if (control) control.focus({ preventScroll: true });
    else { target.tabIndex = -1; target.focus({ preventScroll: true }); }
    target.classList.add('ring-2', 'ring-amber-400', 'ring-offset-2');
    target.addEventListener('blur', () => target.classList.remove('ring-2', 'ring-amber-400', 'ring-offset-2'), { once: true });
    return true;
}
